import { searchContent } from '@plone/volto/actions';
import { FormattedDate, Pagination, PreviewImage, UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Card, Container, Grid, Segment } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

const PublicationsListing = (props) => {
  const dispatch = useDispatch();
  const publications = useSelector((state) => state.search.subrequests.publications?.items);
  const total = useSelector((state) => state.search.subrequests.publications?.total);
  const [pageSize, setPageSize] = useState(12);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const contentFilter = {
      b_size: pageSize,
      b_start: currentPage * pageSize,
      portal_type: 'Publication',
      review_state: 'published',
      sort_on: 'publicationtype_date',
      sort_order: 'descending',
      metadata_fields: ['publicationtype_date']
    }
    dispatch(
      searchContent(
        flattenToAppURL(props.content['@id']),
        contentFilter,
        'publications'
      ),
    )
  }, [dispatch, currentPage, pageSize,])

  const onChangePage = (event) => {
    event.preventDefault();
    setCurrentPage(parseInt(event.target.text) - 1);
  };
  const onChangePageSize = (event) => {
    event.preventDefault();
    setPageSize(parseInt(event.target.text));
    setCurrentPage(0);
  };

  return (
    <>
      {
        publications && (
          <Grid id="content-core" columns={12} as="ul" className='pubListing list-unstyled'>
            {publications.map((item, index) => (
              <Grid.Column key={index} mobile={12} tablet={8} computer={6} as="li" className='justify-content-center' >
                <article className={'pubItem position-relative ' +
                  (item.image_field ? 'pubItem--hasImage' : 'pubItem--noImage')}
                  >
                  {item.image_field && (
                    <PreviewImage
                      item={item}
                      alt=''
                      className="pubItem__img"
                      responsive={true}
                      sizes="(max-width: 768px) 100vw, (max-width: 992px) 66vw, 50vw"
                      loading="lazy"
                    />
                  )}
                  <div className="pubItem__text">
                    <FormattedDate className="pubItem__date"
                      date={item.publicationtype_date}
                      locale="ca"
                      format={{
                        month: "long",
                        year: "numeric",
                      }}
                    />
                    <h3 className="pubItem__title">
                      <UniversalLink
                        href={`${flattenToAppURL(item['@id'])}/@@display-file/publication_document`}
                        className="pubItem__link stretched-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      > {item.title} <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                      </UniversalLink>
                    </h3>
                    {item.description &&
                      <p className="pubItem__desc">{item.description}</p>
                    }
                    <span className="pubItem__readMore ">
                      <FontAwesomeIcon icon={faFileImport} />
                    </span>
                  </div>
                </article>
              </Grid.Column>
            ))}
          </Grid>
        )
      }
      {total > pageSize && (
        <nav className="pagination d-print-none">
          <Pagination
            current={currentPage}
            total={Math.ceil(total / pageSize)}
            onChangePage={onChangePage}
            onChangePageSize={onChangePageSize}
          />
        </nav>
      )}
    </>
  )
}


export default PublicationsListing;